import {BaseDTO} from "./_baseDTO.interface";

export interface MediaDTO extends BaseDTO {
  mediaId: string;
  mediaURL: string;
}
